import React from "react";
import PropTypes from "prop-types";
import { STAGES, INVOICE_STATUSES } from "./partnerPortalShared";

export function StageBadge({ stage, size = "sm" }) {
  const s = STAGES[stage];
  if (!s) return null;
  const pad = size === "sm" ? "4px 9px 4px 8px" : "6px 12px 6px 10px";
  const fs = size === "sm" ? 11.5 : 13;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: pad,
        borderRadius: 999,
        background: s.bg,
        color: s.fg,
        fontSize: fs,
        fontWeight: 600,
        lineHeight: 1,
        letterSpacing: 0.1,
        whiteSpace: "nowrap"
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: 999,
          background: s.dot
        }}
      />
      {s.label}
    </span>
  );
}

StageBadge.propTypes = {
  stage: PropTypes.string,
  size: PropTypes.string
};

export function InvoiceStatusBadge({ status }) {
  const s = INVOICE_STATUSES[status] || INVOICE_STATUSES.funded;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        padding: "3px 8px",
        borderRadius: 99,
        background: s.bg,
        color: s.fg,
        fontSize: 10.5,
        fontWeight: 700,
        lineHeight: 1.2,
        whiteSpace: "nowrap"
      }}
    >
      <span
        style={{
          width: 5,
          height: 5,
          borderRadius: 99,
          background: s.dot,
          flex: "0 0 auto"
        }}
      />
      {s.label}
    </span>
  );
}

InvoiceStatusBadge.propTypes = {
  status: PropTypes.string
};
